export default __webpack_public_path__ + "static/media/victors.0fb4edc0.gif";